import { Box, FormControlLabel } from "@material-ui/core"
import { drillDownStyles } from "../../../../styles"
import { ReactNode } from "react"
import { LegendItemLayout } from "./LegendItemLayout"

export function LegendItemRootLayout({
  children,
  title,
  color,
  selectAll,
}: {
  children: ReactNode
  title: string
  color?: string
  selectAll: boolean
}) {
  return (
    <Box
      display="flex"
      flexDirection="row-reverse"
      justifyContent="space-between"
      padding={selectAll ? "0px 0px 8px 0px" : "8px 0px"}
    >
      <FormControlLabel
        control={<>{children}</>}
        label={<></>}
        className={drillDownStyles.formControl}
      />

      <LegendItemLayout title={title} color={color} selectAll={selectAll} />
    </Box>
  )
}
